import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "w-full bg-white fixed p-[12px] shadow-md z-10" }
const _hoisted_2 = { class: "flex items-center justify-between" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "flex flex-col justify-end text-right text-[14px]" }, [
  /*#__PURE__*/_createElementVNode("div", null, "г. Воронеж"),
  /*#__PURE__*/_createElementVNode("div", null, "ул. Владимира Невского д.19"),
  /*#__PURE__*/_createElementVNode("div", null, "+7 (920) 223-83-33"),
  /*#__PURE__*/_createElementVNode("div", null, "С 10:00 до 19:00")
], -1)
const _hoisted_4 = { class: "mt-[24px]" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_the_logo = _resolveComponent("the-logo")!
  const _component_scroll_menu = _resolveComponent("scroll-menu")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_the_logo),
      _hoisted_3
    ]),
    _createElementVNode("div", _hoisted_4, [
      _createVNode(_component_scroll_menu, {
        items: _ctx.menuItems,
        "current-catalog-id": _ctx.currentCatalogId,
        "is-loading": _ctx.isLoading,
        onUpdateCatalog: _ctx.updateCatalogHandler
      }, null, 8, ["items", "current-catalog-id", "is-loading", "onUpdateCatalog"])
    ])
  ]))
}